import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { Helpers } from '../helpers';
import { ScriptLoaderService } from '../_services/script-loader.service';

@Component({
  standalone: false,
  selector: 'app-theme',
  host: { class: 'm-grid m-grid--hor m-grid--root m-page' },
  templateUrl: './theme.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ThemeComponent implements OnInit, AfterViewInit, OnDestroy {
  private resizeObserver?: ResizeObserver;
  private readonly onResize = () => this.syncHeaderOffset();

  constructor(
    private _script: ScriptLoaderService,
    private _router: Router,
  ) {}

  private metronic(): any {
    return window as any;
  }

  private syncHeaderOffset() {
    const header = document.querySelector('app-header-nav') as HTMLElement | null;
    if (!header) {
      document.documentElement.style.setProperty('--app-header-offset', '70px');
      return;
    }
    const isMobile = window.matchMedia('(max-width: 992px)').matches;
    // En móvil el hit-area del header debe ser solo la barra del logo (60px).
    const height = isMobile
      ? 60
      : Math.max(60, Math.ceil(header.getBoundingClientRect().height || 70));
    document.documentElement.style.setProperty('--app-header-offset', `${height}px`);
  }

  ngAfterViewInit() {
    this.syncHeaderOffset();
    const header = document.querySelector('app-header-nav');
    if (header && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.syncHeaderOffset());
      this.resizeObserver.observe(header);
    }
    window.addEventListener('resize', this.onResize);
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.onResize);
  }

  ngOnInit() {
    // scripts.bundle.js already loaded in index.html; fullcalendar is optional
    this._script
      .load('head', '/assets/vendors/custom/fullcalendar/fullcalendar.bundle.js')
      .catch(() => undefined);
    Helpers.setLoading(false);

    this._router.events.subscribe((route) => {
      const w = this.metronic();
      if (route instanceof NavigationStart) {
        try {
          w.mLayout?.closeMobileAsideMenuOffcanvas?.();
          w.mLayout?.closeMobileHorMenuOffcanvas?.();
          w.mApp?.scrollTop?.();
        } catch {
          /* Metronic not ready */
        }
        // Solo en navegaciones posteriores al primer load (evita "cargando" eterno en F5).
        if (this._router.navigated) {
          Helpers.setLoading(true);
        }
        try {
          ($('[data-toggle="m-popover"]') as any).popover?.('hide');
        } catch {
          /* ignore */
        }
      }
      if (
        route instanceof NavigationEnd ||
        route instanceof NavigationCancel ||
        route instanceof NavigationError
      ) {
        try {
          if (route instanceof NavigationEnd) {
            w.mApp?.init?.();
            w.mUtil?.init?.();
            setTimeout(() => this.syncHeaderOffset(), 0);
          }
        } catch {
          /* Metronic not ready */
        }
        Helpers.setLoading(false);
        if (route instanceof NavigationEnd) {
          const animation = 'm-animate-fade-in-up';
          const wrapper = $('.m-wrapper');
          if (wrapper?.length) {
            wrapper
              .one(
                'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                () => {
                  wrapper.removeClass(animation);
                },
              )
              .removeClass(animation)
              .addClass(animation);
          }
        }
      }
    });
  }
}
